import { useQuery } from '@tanstack/react-query'
import { getCountryCallingCode, isSupportedCountry } from 'libphonenumber-js'

import type { SmsCoverageResponse } from '@/bindings/SmsCoverageResponse'
import { request } from '@/lib/api'

/**
 * Which calling codes get an automated SMS (I1). Fetched once per session:
 * the list is config on the server and changes with a deploy, not at runtime.
 * Unknown (still loading, or failed) counts as covered — a hint that flashes
 * on while the answer is in flight would be worse than a late one.
 */
export function useSmsCoverage(enabled = true) {
  const query = useQuery({
    queryKey: ['sms-coverage'],
    queryFn: () => request<SmsCoverageResponse>('/auth/sms-coverage'),
    staleTime: Infinity,
    enabled,
  })
  const codes = query.data?.calling_codes
  return (nation: string): boolean => {
    if (!codes || !isSupportedCountry(nation)) return true
    return codes.includes(getCountryCallingCode(nation))
  }
}
